import urls from "@/constants/urls.js";
import axios from "axios";

const state = {
  publicKeyTest: "pk_test_PMsOfZJpfPpg6khrhCGjNHz6",
  publicKeyLive: "",
  secretKey: "",
  cards: [],
  // the donor's Meshulam cards, kept next to their Stripe cards
  meshulamCards: [],
  // whether the server lets the donor add one (a Charidy Meshulam account is
  // configured and its cards work for other organizations' campaigns)
  meshulamCardsAvailable: false,
};

const mutations = {
  setPublicKeyLive(state, data) {
    state.publicKeyLive = data;
  },
  setCards(state, data) {
    state.cards = data;
  },
  setMeshulamCards(state, { methods, available }) {
    state.meshulamCards = methods;
    state.meshulamCardsAvailable = available;
  },
};

const actions = {
  getPublicKeyLive({ commit }) {
    const params = { stripe_prod_public_key: 1 };
    axios.get(urls.initPage, { params }).then(({ data }) => {
      const { public_key } = data.included[0].attributes;
      commit("setPublicKeyLive", public_key);
    });
  },

  getCards({ commit }, { throwOnError = false } = {}) {
    return axios
      .get(urls.donorCardsStripe.replace("/:cardId", ""))
      .then((response) => {
        let cards = response.data.data ? response.data.data : [];
        commit("setCards", cards);
        return cards;
      })
      .catch((e) => {
        if (throwOnError) throw e;
        console.log(e);
      });
  },

  getMeshulamCards({ commit }) {
    return axios
      .get(urls.donorCardsMeshulam.replace("/:cardId", ""))
      .then(({ data }) => {
        const cards = data?.data?.methods || [];
        commit("setMeshulamCards", { methods: cards, available: Boolean(data?.data?.available) });
        return cards;
      })
      .catch((e) => {
        console.log(e);
      });
  },

  setDefaultCard(_, cardId) {
    return axios.put(urls.donorDefaultCardStripe.replace(":cardId", encodeURIComponent(cardId)));
  },
};

export default {
  state,
  actions,
  mutations,
};
